
import React, { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { Modal } from 'bootstrap';
const ManufacturerModal = forwardRef(({ onSearch, initialSearchForm }, ref) => {

    const modalElem = useRef(null);
    const modal = useRef(null);
    const initSearchForm = {
        search_name: '',
    };

    const searchFormLabel = {
        search_name: 'Name : ',
    };

    const [manufacturerSearchForm, setManufacturerSearchForm] = useState({ ...initSearchForm, ...initialSearchForm });
    const resetForm = () => {
        setManufacturerSearchForm({ ...initSearchForm });
    };



    useImperativeHandle(ref, () => ({
        initModalHandler: () => {
            modalOpen();
        },
        resetForm: resetForm
       
    }));

    const modalOpen = () => {
        if (modal.current) { modal.current.show(); }
    };

    const modalClose = () => {
        if (modal.current) { modal.current.hide(); }
        
    };

    useEffect(() => {
        modalElem.current = document.getElementById('searchModal');
        modal.current = new Modal(modalElem.current, { keyboard: false, backdrop: false });
        return () => {
            if (modal.current) {
                modal.current.dispose();
            }
        };
    }, []);

    const submitSearchForm = (e) => {
        e && e.preventDefault()
        let serachFormKeys = Object.keys(manufacturerSearchForm);
        let searchedElems = [];
        let searchParams = {};
        serachFormKeys.map((key) => {

            let label = searchFormLabel[key];
            let value = manufacturerSearchForm[key];

            if (value && value.toString().length > 0) {
                searchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'search_name') {
                        show_val = manufacturerSearchForm ? manufacturerSearchForm.search_name : '';
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        onSearch(searchParams, searchedElems);
        modalClose()
    }
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setManufacturerSearchForm(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const searchModalJsx = () => {
        return (
            <div className="modal fade" id="searchModal" tabIndex="-1" ref={modalElem}>
                <div className="modal-dialog modal-lg">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title" id="searchAssetModalLabel">Manufacturer Search</h5>
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <form id="manufacturerSearchForm" onSubmit={submitSearchForm}>
                            <div className="modal-body">
                                <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">Name</label>
                                    <div className="col-sm-10">
                                        <input
                                            name="search_name"
                                            type="text"
                                            value={manufacturerSearchForm.search_name}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            placeholder="Please enter Manufacturer Name"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                </div>
                                {/* <div className="row my-3 align-items-center">
                                    <label className="col-sm-2 col-form-label col-form-label-sm">NickName</label>
                                    <div className="col-sm-10">
                                        <input
                                            name=""
                                            type="text"
                                            value={manufacturerSearchForm.}
                                            className="form-control"
                                            autoComplete="off"
                                            onChange={handleInputChange}
                                            placeholder="Please enter NickName"
                                            style={{ height: "30px", fontSize: "93%" }}
                                        />
                                    </div>
                                </div> */}
                            </div>
                            <div className="modal-footer">
                                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Close</button>
                                <button type="submit" className="btn btn-primary">Search</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <>
            {searchModalJsx()}
        </>
    );
});

export default ManufacturerModal;
